export default "__VITE_PUBLIC_ASSET__aea28b5b__"